import { Link } from 'react-router-dom'
import SectionHead from './SectionHead'

const TRUST_ITEMS = [
  {
    title: 'Runs in the browser',
    description: 'No install, no extension, no admin agent on the machine.',
  },
  {
    title: 'No integrations',
    description: 'Day One never connects to your internal systems, APIs or databases.',
  },
  {
    title: 'You choose what goes in',
    description: 'Describe a workflow at whatever level of detail you are comfortable with.',
  },
  {
    title: 'Not used for model training',
    description: 'Stored encrypted on Google Cloud, deletable from your account at any time.',
  },
]

export default function SecurityTrustSection() {
  return (
    <section className="bg-surface py-14 md:py-16 border-y-2 border-navy">
      <div className="mktg-container">
        <SectionHead
          mark="SECT. 06"
          title="Privacy focused"
          note="What your security reviewer will want to see, written down in advance."
        />

        <div className="grid md:grid-cols-[minmax(0,1fr)_auto] gap-6 md:gap-10 items-start max-w-4xl">
          <ol className="ledger">
            {TRUST_ITEMS.map((item) => (
              <li key={item.title} className="flex gap-4 p-5">
                <span className="waypoint waypoint-teal mt-2 shrink-0" aria-hidden="true" />
                <div>
                  <h3 className="font-display text-lg text-navy mb-0.5">{item.title}</h3>
                  <p className="text-navy/70 text-sm leading-relaxed">{item.description}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="card card-shadow p-5 md:w-64 bg-stone">
            <p className="mono-label text-teal border-b-2 border-navy pb-2 mb-3">
              For your IT team
            </p>
            <p className="text-sm text-navy/75 leading-relaxed mb-4">
              Some corporate web filters block new domains by default. The security page
              lists every domain to allow, plus our subprocessors and retention rules.
            </p>
            <div className="flex flex-col gap-2">
              <Link to="/security" className="btn btn-teal w-full">
                IT and security guide
              </Link>
              <Link to="/dpa" className="btn w-full">
                Read the DPA
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
